import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import LabeledField from '../../components/LabeledField';
import { useLocale } from '../../context/LocaleContext';
import { useTimezonePickerStyles } from './TimezonePicker.styles';
import { buildTimezoneGroups } from './operators/buildTimezoneGroups';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimezonePicker = ({
  name,
  value,
  label,
  labelLayout,
  width = 'full',
  required,
  isDisabled = false,
  onChange
}) => {
  const locale = useLocale();
  const {
    selectStyle
  } = useTimezonePickerStyles({
    isDisabled,
    width
  });
  const groups = useMemo(() => buildTimezoneGroups(locale), [locale]);
  const selectId = `timezone-picker-${name}`;
  const handleChange = e => {
    onChange(name, e.target.value);
  };
  return /*#__PURE__*/_jsx(LabeledField, {
    htmlFor: selectId,
    label: label,
    required: required,
    labelLayout: labelLayout,
    children: /*#__PURE__*/_jsxs("select", {
      id: selectId,
      value: value,
      onChange: handleChange,
      required: required,
      disabled: isDisabled,
      style: selectStyle,
      children: [value === '' && /*#__PURE__*/_jsx("option", {
        value: "",
        disabled: true,
        children: unescapedText('interactiveCards.timezonePicker.placeholder')
      }), groups.map(group => /*#__PURE__*/_jsx("optgroup", {
        label: group.region,
        children: group.options.map(option => /*#__PURE__*/_jsx("option", {
          value: option.value,
          children: option.label
        }, option.value))
      }, group.region))]
    })
  });
};
export default TimezonePicker;